import { StyledSlider } from '@/pages/AdvancedEditor/components/panels/common/StyledSlider';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getAvatarElementFromPage, getAvatarGroupFromPage } from '@/pages/AdvancedEditor/utils';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlNumberInput } from '../../../common/ControlNumberInput';

const Container = styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    width: 220px;
`;

export const BorderWidthControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const avatarElement = getAvatarElementFromPage(store.activePage);

    if (!avatarElement) return null;

    const group = getAvatarGroupFromPage(store.activePage);
    const circleElement = group?.children.find(
        (child: ElementType) => child.type === 'figure' && child.subType === 'circle' && child.name === 'avatar-border'
    );

    if (!circleElement) return null;

    const handleChange = (value: number) => {
        circleElement.set({ strokeWidth: value });
    };

    return (
        <Container>
            <StyledSlider
                value={circleElement.strokeWidth}
                onChange={(_e, value) => handleChange(value as number)}
                step={1}
                min={0}
                max={100}
            />
            <ControlNumberInput value={circleElement.strokeWidth} onChange={handleChange} min={0} max={100} suffix="px" />
        </Container>
    );
});
